<template>
    <div
        v-if="globalError"
        class="global-error"
        :class="{ 'show-global-error': globalError }"
    >
        <div class="global-error__content" v-html="globalError" />
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, watch, onMounted } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
    name: 'GlobalError',
    setup() {
        const store = useStore();
        const error = ref<string | null>(null);

        const globalError = computed(() => store.state.globalError);
        watch(globalError, (newValue) => {
            error.value = newValue;

            if (newValue && newValue.length) {
                scrollTo(500);
            }
        });

        const scrollTo = (time: number) => {
            const posY = window.scrollY;
            let value = 0;

            const scrollToError = setInterval(() => {
                if (window.scrollY <= 0) {
                    clearInterval(scrollToError);
                }
                value = posY / time;
                window.scrollTo(0, window.scrollY - value);
            });
        };

        onMounted(() => {
            if (error.value) {
                scrollTo(500);
            }
        });

        return {
            globalError,
            error,
            scrollTo,
        };
    },
});
</script>
